<template>
  <v-row justify="center">
    <v-dialog v-model="active" max-width="400"> 
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          請至信箱中收信
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; height:80px; font-size:15px">
          系統已將您的密碼，寄到您註冊時所輸入的電子信箱中，請開啟信箱確認。
        </v-card-text>
        <v-row  justify="center">          
          <v-card-actions>          
            <v-btn outlined color="#FFF" style="width: 150px; height:46px; border-radius: 10px; background:#81C0E2"
            @click="save">
              確定
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'ReceiveMail',
    props:['onSave'],
    data () {
      return {
        active: false,
      }
    },
    methods:{
      open(data){
        this.active = true
        this.sendType = data
      },
      close(){
        this.active = false
      },
      save(){
        this.onSave()
      }
    }
  }
</script>